import { defineMessages } from '@transcend-io/internationalization';

// Define the `aria-label` for the `select` element
export const selectMessages = defineMessages(
  'privacy-center.containers.LocaleToggle.select',
  {
    icon: {
      defaultMessage: 'Select your language',
    },
    label: {
      defaultMessage: 'Language selector',
    },
  },
);
